import React from 'react';
import { ApiAppParams } from '@typings/apiApp';
import ReactDOM from 'react-dom/client';

import { EmbeddedPage } from '@/modules/embedded-page';

import { config } from "./config";
import desktopBg from './golf-simulator-background-desktop.jpg';
import mobileBg from './golf-simulator-background-mobile.jpg';


ReactDOM.createRoot(document.getElementById('saywhatt-page')!).render(
  <EmbeddedPage
    config={config as unknown as ApiAppParams}
    spinnerElement={document.querySelector('#saywhatt-loader')}
    // 216px (D)
    // 95px (M)
    // sections={[
    //   document.getElementById('shopify-section-sections--25815959241069__utility-bar'),
    //   document.querySelector('.site-header'),
    // ]}
    welcomeScreenTitle="Welcome to Golf Simulator Expert AI"
    desktopBg={desktopBg}
    mobileBg={mobileBg}
  />
);